export default __webpack_public_path__ + "static/media/hashtag.14218a6a.svg";